<template>
    <header :class="['navbar-wrapper', { 'navbar-scrolled': scrolled }]">
        <nav class="navbar">
            <div class="navbar-logo">
                <router-link to="/">
                    <img 
                        v-if="config && config.site_logo" 
                        :src="`/storage/${config.site_logo}`" 
                        :alt="config.site_name || 'Logo'"
                    >
                    <img 
                        v-else 
                        src="https://via.placeholder.com/200x50/1e3a5f/d4af37?text=POS+Solutions" 
                        alt="Logo"
                    >
                </router-link>
            </div>
            
            <div :class="['navbar-menu', { 'mobile-menu-open': mobileMenuOpen }]">
                <ul class="nav-list">
                    <li class="nav-item">
                        <router-link to="/" class="nav-link" @click.native="closeMobileMenu">
                            Inicio
                        </router-link>
                    </li>
                    
                    <!-- Menú de Productos con Categorías -->
                    <li class="nav-item dropdown" v-if="categorias && categorias.length">
                        <a href="#" class="nav-link dropdown-toggle" @click.prevent>
                            Productos
                            <i class="fas fa-chevron-down"></i>
                        </a>
                        <div class="dropdown-menu">
                            <router-link 
                                v-for="categoria in categorias" 
                                :key="categoria.id"
                                :to="`/productos/${categoria.id}/${categoria.slug}`"
                                class="dropdown-item"
                                @click.native="closeMobileMenu"
                            >
                                {{ categoria.nombre }}
                            </router-link>
                        </div>
                    </li>
                    
                    <!-- Menú de Soporte y Descarga -->
                    <li class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" @click.prevent>
                            Soporte y Descarga
                            <i class="fas fa-chevron-down"></i>
                        </a>
                        <div class="dropdown-menu">
                            <router-link to="/drivers-descargas" class="dropdown-item" @click.native="closeMobileMenu">
                                Drivers y Descargas
                            </router-link>
                            <router-link to="/soporte-tecnico" class="dropdown-item" @click.native="closeMobileMenu">
                                Soporte Técnico
                            </router-link>
                        </div>
                    </li>
                    
                    <li class="nav-item">
                        <router-link to="/contacto" class="nav-link" @click.native="closeMobileMenu">
                            Contacto
                        </router-link>
                    </li>
                    
                    <li class="nav-item">
                        <router-link to="/blog" class="nav-link" @click.native="closeMobileMenu">
                            Blog
                        </router-link>
                    </li>
                </ul>
            </div>
            
            <button class="menu-toggle" @click="toggleMobileMenu">
                <span></span>
                <span></span>
                <span></span>
            </button>
        </nav>
    </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'Navbar',
    data() {
        return {
            scrolled: false,
            mobileMenuOpen: false
        };
    },
    computed: {
        ...mapState(['config']),
        ...mapGetters(['categorias'])
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.scrolled = window.scrollY > 50;
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        closeMobileMenu() {
            this.mobileMenuOpen = false;
        }
    }
};
</script>

<style scoped>
.navbar-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    background: rgba(10, 22, 40, 0.7);
    backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(212, 175, 55, 0.1);
}

.navbar-wrapper.navbar-scrolled {
    background: rgba(10, 22, 40, 0.95);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.navbar {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.2rem 2rem;
}

.navbar-logo img {
    height: 50px;
    width: auto;
    max-width: 200px;
    transition: transform 0.3s ease;
}

.navbar-logo a:hover img {
    transform: scale(1.05);
}

.navbar-menu {
    display: flex;
    align-items: center;
}

.nav-list {
    display: flex;
    list-style: none;
    gap: 2.5rem;
    align-items: center;
}

.nav-link {
    color: var(--text-light);
    text-decoration: none;
    font-weight: 500;
    font-size: 0.95rem;
    position: relative;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
}

.nav-link::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: var(--accent-gold);
    transition: width 0.3s ease;
}

.nav-link:hover::after,
.nav-link.router-link-active::after {
    width: 100%;
}

.nav-link:hover,
.nav-link.router-link-active {
    color: var(--accent-gold);
}

.dropdown {
    position: relative;
}

.dropdown-toggle {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.dropdown-toggle i {
    font-size: 0.7rem;
    transition: transform 0.3s ease;
}

.dropdown:hover .dropdown-toggle i {
    transform: rotate(180deg);
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background: var(--card-bg);
    border-radius: 12px;
    padding: 0.8rem 0;
    min-width: 220px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: all 0.3s ease;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(212, 175, 55, 0.2);
    margin-top: 0.5rem;
}

.dropdown:hover .dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.dropdown-item {
    display: block;
    padding: 0.8rem 1.5rem;
    color: var(--text-light);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
}

.dropdown-item:hover {
    background: rgba(212, 175, 55, 0.1);
    color: var(--accent-gold);
    padding-left: 2rem;
}

.menu-toggle {
    display: none;
    flex-direction: column;
    gap: 5px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 5px;
}

.menu-toggle span {
    width: 25px;
    height: 3px;
    background: var(--accent-gold);
    transition: all 0.3s ease;
    border-radius: 2px;
}

/* MOBILE STYLES */
@media (max-width: 1024px) {
    .menu-toggle {
        display: flex;
    }
    
    .navbar-menu {
        position: fixed;
        top: 80px;
        left: 0;
        width: 100%;
        background: rgba(10, 22, 40, 0.98);
        backdrop-filter: blur(20px);
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.4s ease;
        border-bottom: 1px solid rgba(212, 175, 55, 0.1);
    }
    
    .navbar-menu.mobile-menu-open {
        max-height: 500px;
    }
    
    .nav-list {
        flex-direction: column;
        gap: 0;
        padding: 1rem 0;
    }
    
    .nav-item {
        width: 100%;
    }
    
    .nav-link {
        display: block;
        padding: 1rem 2rem;
    }
    
    .dropdown-menu {
        position: static;
        opacity: 1;
        visibility: visible;
        transform: none;
        background: rgba(30, 58, 95, 0.5);
        border: none;
        margin-top: 0;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
    }
    
    .dropdown:hover .dropdown-menu {
        max-height: 300px;
    }
    
    .dropdown-item {
        padding: 0.8rem 3rem;
    }
    
    .dropdown-item:hover {
        padding-left: 3.5rem;
    }
}
</style>
